// Combine contact[firstname] + contact[lastname] into the hidden contact[name]
// field expected by Shopify's native contact form on submit.
document.addEventListener('submit', (event) => {
  const form = event.target;
  const fullNameField = form.querySelector('[data-contact-form-fullname]');
  if (!fullNameField) return;

  const firstname = form.querySelector('[data-contact-form-firstname]')?.value.trim() || '';
  const lastname = form.querySelector('[data-contact-form-lastname]')?.value.trim() || '';
  fullNameField.value = [firstname, lastname].filter(Boolean).join(' ');
});
